import { render } from "./Todays.vue?vue&type=template&id=3f36621d"
import script from "./Todays.vue?vue&type=script&lang=js"
export * from "./Todays.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Todays.vue?vue&type=style&index=1&id=3f36621d&lang=css"

import exportComponent from "/var/www/html/moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__